<template>
  <v-container grid-list-xl text-xs-center style="margin: 0 !important;">
    <v-layout
      row
      class="align-center layout px-4 pt-4 app--page-header"
      style="padding-top: 30px !important;"
    >
      <v-breadcrumbs divider=" " style="padding: 0;">
        <v-breadcrumbs-item>
          <v-toolbar-title class="subtitle2Text" v-on:click="goToDashboard(1)" style="cursor: pointer;">{{ PageHeader }}</v-toolbar-title>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item v-if="this.$store.state.PageHeaderSub.length > 0">
          <v-icon medium :color="colorTheme" style="font-size: 36px">mdi-chevron-right</v-icon>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item v-if="this.$store.state.PageHeaderSub.length > 0">
          <v-toolbar-title
            class="subtitle2Text"
            v-on:click="goToDashboard(2)"
            style="cursor: pointer;"
          >{{ PageHeaderSub }}</v-toolbar-title>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item v-if="this.$store.state.PageHeaderSub1.length > 0">
          <v-icon medium :color="colorTheme" style="font-size: 36px">mdi-chevron-right</v-icon>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item v-if="this.$store.state.PageHeaderSub1.length > 0">
          <v-toolbar-title
            class="subtitle2Text"
            v-on:click="goToDashboard(3)"
            style="cursor: pointer;"
          >{{ PageHeaderSub1 }}</v-toolbar-title>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item v-if="this.$store.state.PageHeaderSub2.length > 0">
          <v-icon medium :color="colorTheme" style="font-size: 36px">mdi-chevron-right</v-icon>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item v-if="this.$store.state.PageHeaderSub2.length > 0">
          <v-toolbar-title
            class="subtitle2Text"
            v-on:click="goToDashboard(4)"
            style="cursor: pointer;"
          >{{ PageHeaderSub2 }}</v-toolbar-title>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item
          :disabled="disableButton"
          v-on:click="refresh()"
          v-if="this.$store.state.refreshOnHeader"
        >
          <v-btn text :disabled="disableButton" icon :color="colorTheme">
            <v-icon medium>mdi-autorenew</v-icon>
          </v-btn>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "colorTheme",
      "disableButton",
      "PageHeader",
      "PageHeaderSub",
      "PageHeaderSub1",
      "PageHeaderSub2",
      "refreshOnHeader"
    ])
  },
  methods: {
    async refresh() {
      if (this.$route.path == "/reportsPage") {
        this.$store.dispatch("getListOfReports");
      }
      if (this.$route.path == "/dashboard") {
        this.$store.dispatch("getItemsDashboard", [true, false]);
      }
      if (this.$route.path == "/accountManager") {
        this.$store.dispatch("getSecureUsers");
      }
      if (this.$route.path == "/operator") {
        this.$store.dispatch("ListofOperators");
      }
      if (this.$route.path == "/mobilePhone") {
        this.$store.dispatch("ListofMovil");
      }
      if (this.$route.path == "/traffic") {
        this.$store.dispatch("ListOfTraffic");
      }
      if (this.$route.path == "/carriers") {
        this.$store.dispatch("ListofCariers");
      }
      if (this.$route.path == "/dashboard/performance") {
        this.$store.dispatch("getDetailsTable");
      }
      if (this.$route.path == "/dashboard/performance/individual") {
        this.$store.dispatch("getItemsIP");
      }
      if (this.$route.path == "/dashboard/performance/comparative") {
        var ItemsPerformance = this.$store.state.itemsPerformanceInfo;
        if (ItemsPerformance == null) {
          ItemsPerformance = await this.$store.dispatch(
            "getItemPouchdb",
            "ItemsPerformance"
          );
        }
        this.$store.dispatch("divideData", {
          itemsPerformance1: ItemsPerformance,
          comparative: true,
          byTrip: false
        });
      }
      if (this.$route.path == "/individualFuel") {
        var vehicle = localStorage.getItem("vehicleAF");
        if (vehicle != null || vehicle != undefined) {
          vehicle = JSON.parse(vehicle);
          this.$store.commit("viewSkeletonsFP", true);
          this.$store.commit("viewSkeletonsAR", true);
          this.$store.commit("viewSkeletonsRL", true);
          this.$store.dispatch("lastLevelWS", {
            vehicleId: vehicle.MovilId
          });
          this.$store.dispatch("fuelPerformance", {
            vehicleId: vehicle.MovilId,
            showMore: false
          });
        }
      }
      if (this.$route.path == "/settingsAT") {
        if (this.$store.state.showVehiclesAT) {
          this.$store.dispatch("catalogVehAT");
        } else {
          this.$store.dispatch("catalogTemplatesAT");
        }
      }
      if (this.$route.path == "/settingsAT/verifyConfiguration") {
        this.$store.dispatch("contentVehicleAT");
      }
      if (this.$route.path == "/dashboard/alertruckVehiclesInfo") {
        this.$store.dispatch("getAlertruckVehiclesInfo");
      }
    },
    goToDashboard(val) {
      if (
        this.$route.name != "dashboard" &&
        this.$store.state.PageHeader == this.$t("dashboard").toUpperCase()
      ) {
        this.$router.back();
      }

      if (val == 1) {
        if (this.$route.name == "individual") {
          this.$router.back();
        } else if (this.$route.name == "comparative") {
          this.$router.back();
          this.$router.back();
        } else if (this.$route.name == "verifyConfiguration") {
          this.$router.back();
        } else if (this.$route.name == "configurationProgress") {
          this.$router.back();
        } 

        if (
          this.$store.state.PageHeader ==
          this.$t("configTemplates").toUpperCase()
        ) {

          this.$store.commit("showVehiclesAT", false);
          localStorage.setItem("showVehiclesAT", false);

          this.$store.commit("showTemplates", true);
          this.$store.commit("setPageHeader", [
            this.$t("configTemplates").toUpperCase(),
            "",
            "",
            "",
            true
          ]);

          if (this.$route.path == "/settingsAT/assignTemplate") {
            this.$router.back();
          }
        }
      } else if (val == 2) {
        if (this.$route.name == "comparative") {
          this.$router.back();
        }
      }
    },
    goToColectivePerformance() {
      if (
        this.$route.name != "performance" &&
        this.$store.state.PageHeader == this.$t("dashboard").toUpperCase()
      ) {
        //this.$router.back();
      }
    },
    GoToPerformance() {}
  }
};
</script>
<style scoped>
.return-dashboard {
  cursor: pointer;
}

.v-breadcrumbs li:nth-child(2n) {
    padding: 0 4px;
}
</style>
